import { render } from "./TabooPattern.vue?vue&type=template&id=2ee84089&scoped=true"
import script from "./TabooPattern.vue?vue&type=script&lang=js"
export * from "./TabooPattern.vue?vue&type=script&lang=js"

import "./TabooPattern.vue?vue&type=style&index=0&id=2ee84089&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ee84089"]])

export default __exports__